import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';

export const useExtractProfile = () => {
  const { push } = useToast();

  return useMutation({
    mutationFn: (text: string) =>
      fetchJson<{ profile: Record<string, unknown> }>('/api/profile/extract', {
        body: JSON.stringify({ text }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      }),
    onError: (error: Error) =>
      push(error.message || 'Profile extraction failed', 'error'),
  });
};
